import FormProperties from './FormProperties'
import { Card, CardActions, CardContent, Divider } from '@material-ui/core'
import React from 'react'
import { components } from 'cng-web-lib'
import { useParams } from 'react-router-dom'
import ConveyanceMasterApiUrls from 'src/apiUrls/ConveyanceMasterApiUrls'
import pathMap from '../../paths/pathMap'
import ConveyanceMasterTranslationText from './context/ConveyanceMasterTranslationText'

const {
  button: { CngButton },
  form: { CngViewForm }
} = components

function ConveyanceViewPage({ history, showNotification }) {
  const { id } = useParams()
  const conveyanceMasterTranslationText = ConveyanceMasterTranslationText()

  return (
    <Card>
      <CardContent>
        <CngViewForm
          fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
          showNotification={showNotification}
          renderBodySection={(labelMap, shouldHideMap) => (
            <FormProperties.Fields
              disabled
              isView
              showNotification={showNotification}
              shouldHideMap={shouldHideMap}
            />
          )}
          formikProps={FormProperties.formikProps}
          toClientDataFormat={FormProperties.toClientDataFormat}
          toServerDataFormat={FormProperties.toServerDataFormat}
          fetch={{
            id: id,
            url: ConveyanceMasterApiUrls.GET
          }}
        />
      </CardContent>
      <Divider />
      <CardActions style={{ padding: 16, justifyContent: 'space-between' }}>
        <CngButton color='secondary' onClick={() => history.push(pathMap.CONV_MAST_LIST_VIEW)}>
          {conveyanceMasterTranslationText.backToConveyanceMasterList}
        </CngButton>
      </CardActions>
    </Card>
  )
}

export default ConveyanceViewPage
